import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client/core'
import { ApolloLink } from '@apollo/client/link/core'
import { getWindow, jsonTryParse } from '@ztechapps/common.utils'
import { appSettings } from './settings'

export const setupApolloClient = ({ accessToken, uri }: { accessToken?: string; uri?: string } = {}) => {
  //on node environment this wind value is not defined
  const win = getWindow()

  uri = uri ?? `${appSettings.AppUrl.api}/graphql?tenantId=DFT`
  accessToken = accessToken ?? win?.localStorage?.getItem?.('app-login-token')

  //switch to specific URL depending when the token is available
  const apolloState = jsonTryParse(win?.__APOLLO_STATE__) //this can be empty object on node
  const cache = new InMemoryCache().restore(apolloState)

  //create the http middleware
  const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers, accessing the local storage should be here so it will be executed
    //everytime there is a need for context
    operation.setContext({
      headers: {
        'totalmilk-login-token': accessToken,
        credentials: 'include',
      },
    })
    return forward(operation)
  })

  // Create the http link. Apollo's HttpLink falls back to `globalThis.fetch`
  // when no `fetch` option is passed — in the browser this is the native DOM
  // fetch, and in Node 18+ this is the built-in undici-based fetch (Node 22
  // in our container). Undici maintains a per-origin keep-alive connection
  // pool by default, so SSR no longer burns a fresh TCP + DNS handshake on
  // every GraphQL call to the API (previously via cross-fetch → node-fetch,
  // which created a fresh `http.Agent` per request and ignored globalAgent).
  const httpLink = new HttpLink({ uri })
  // const uploadLink = createUploadLink({ uri: appSettings?.AppService?.graphqlUrl })

  //create the error link for the http only
  //const transportLink = split(hasNoUserContextOperation, httpLink, uploadLink)
  const authHttpLink = ApolloLink.from([authMiddleware, httpLink])

  return new ApolloClient({
    ssrMode: true,
    link: authHttpLink,
    cache,
    ssrForceFetchDelay: 100,
  })
}
